const RELEASE_FILTER_STORAGE_PREFIX = "decisively.releaseFilter";

export const getReleaseFilterStorageKey = (filterKey: string, projectId?: string | null) =>
  `${RELEASE_FILTER_STORAGE_PREFIX}.${filterKey}.${projectId ?? "none"}`;

interface StoredReleaseFilterValue {
  releaseId: string;
  label?: string;
}

const parseStoredReleaseFilterValue = (rawValue: string | null): StoredReleaseFilterValue | null => {
  if (!rawValue) return null;

  try {
    const parsed = JSON.parse(rawValue);
    if (parsed && typeof parsed === "object" && typeof parsed.releaseId === "string") {
      return {
        releaseId: parsed.releaseId,
        label: typeof parsed.label === "string" ? parsed.label : undefined,
      };
    }
  } catch {
    return null;
  }

  return null;
};

const getStoredReleaseFilter = (filterKey: string, projectId?: string | null): StoredReleaseFilterValue | null => {
  try {
    return parseStoredReleaseFilterValue(localStorage.getItem(getReleaseFilterStorageKey(filterKey, projectId)));
  } catch {
    return null;
  }
};

export const getStoredReleaseFilterValue = (filterKey: string, projectId?: string | null): string | null => {
  return getStoredReleaseFilter(filterKey, projectId)?.releaseId ?? null;
};

export const getStoredReleaseFilterLabel = (filterKey: string, projectId?: string | null): string | null => {
  return getStoredReleaseFilter(filterKey, projectId)?.label ?? null;
};

export const setStoredReleaseFilterValue = (
  filterKey: string,
  projectId: string | null | undefined,
  releaseId: string | null,
  label?: string | null,
) => {
  try {
    const storageKey = getReleaseFilterStorageKey(filterKey, projectId);
    if (releaseId) {
      localStorage.setItem(storageKey, JSON.stringify({ releaseId, ...(label ? { label } : {}) }));
    } else {
      localStorage.removeItem(storageKey);
    }
  } catch {
    // ignore
  }
};
